import { Percomatic } from '@biggby-coffee/percomatic-typescript';

import { atom, DefaultValue, selector } from 'recoil';
import { JSONTables, ScreenMessage } from './types';
import { defined } from './utils/defined';
import { fetchProductData } from './utils/fetchProductData';
// import { getNow } from './utils/getNow';
// import { DateTime } from 'luxon';

// export const nowState = atom<DateTime>({
// 	key: 'now',
// 	default: getNow(),
// 	effects_UNSTABLE: [
// 		({ setSelf }) => {
// 			setInterval(() => {
// 				setSelf(getNow());
// 			}, 60000);
// 		}
// 	]
// });

export const jsonTablesState = selector<JSONTables>({
	key: 'jsonTables',
	get() {
		return fetchProductData();
	}
});

export const isAlertsContainerMountedState = atom<boolean>({
	key: 'isAlertsContainerMounted',
	default: false
});

/**
 * Tracks internal state of Percomatic on the worker thread
 */
export const percomaticState = atom<Percomatic.State>({
	key: 'percomatic',
	default: {
		ui: {
			homeScreenHandler: {
				orderScreenHandler: {
					componentQuantities: [],
					processingCreditCard: false,
					selectedItemIndex: -1,
					ticketPayments: [],
					ticketItems: {
						transItems: []
					},
					modifyScreenHandler: {
						productVersions: {
							productVersions: [],
							selectedIndex: -1
						},
						sizes: {
							sizes: [],
							selectedIndex: -1
						}
					}
				}
			}
		}
	}
	// effects_UNSTABLE: [
	// 	({ onSet }) => {
	// 		onSet(percomaticState => {
	// 			console.debug('percomaticState', percomaticState);
	// 		});
	// 	}
	// ]
});

/**
 * tracks progress of init and link
 */
export const initAndLinkProgressState = atom<number>({
	key: 'initAndLinkProgress',
	default: 0
});

/**
 * tracks progress of init and link
 */
export const initAndLinkProgressMessageState = atom<string>({
	key: 'initAndLinkProgressMessage',
	default: 'Downloading menu data...'
});

/**
 * tracks error messages in product selection
 */
export const screenMessageState = atom<ScreenMessage | undefined>({
	key: 'screenMessage',
	default: undefined,
	effects_UNSTABLE: [
		({ onSet, resetSelf }) => {
			let timeoutId: number | undefined;

			onSet(newValue => {
				if (
					defined(newValue) &&
					!(newValue instanceof DefaultValue) &&
					defined(newValue.duration)
				) {
					if (defined(timeoutId)) clearTimeout(timeoutId);

					timeoutId = setTimeout(() => {
						timeoutId = undefined;

						resetSelf();
					}, newValue.duration * 1000) as unknown as number;
				}
			});
		}
	]
});

/**
 * tracks if cart is loaded into the transaction or not yet
 */
export const transactionLoadedState = atom<boolean>({
	key: 'transactionLoaded',
	default: false
});

export const initAndLinkCompleteState = selector<boolean>({
	key: 'initAndLinkComplete',
	get({ get }) {
		const initAndLinkProgress = get(initAndLinkProgressState);

		return initAndLinkProgress === 100;
	}
});

/**
 * tracks if percomatic is ready
 */
export const percomaticLoadedState = selector<boolean>({
	key: 'percomaticLoaded',
	get({ get }) {
		const initAndLinkComplete = get(initAndLinkCompleteState);

		return initAndLinkComplete;
	}
});

export const orderScreenHandlerState =
	selector<Percomatic.Serialized.OrderScreenHandler>({
		key: 'orderScreenHandler',
		get({ get }) {
			return get(percomaticState).ui.homeScreenHandler.orderScreenHandler;
		}
	});

export const modifyScreenHandlerState =
	selector<Percomatic.Serialized.ModifyScreenHandler>({
		key: 'modifyScreenHandler',
		get({ get }) {
			return get(orderScreenHandlerState).modifyScreenHandler;
		}
	});

/**
 * gets "ContextProperty" "transItem"
 */
export const transItemState = selector<
	Percomatic.Serialized.TransItem | undefined
>({
	key: 'transItem',
	get({ get }) {
		const modifyScreenHandler = get(modifyScreenHandlerState);

		return modifyScreenHandler.transItem;
	}
});

export const currentTransState = selector<
	Percomatic.Serialized.OrderScreenHandler['currentTrans']
>({
	key: 'currentTrans',
	get({ get }) {
		const orderScreenHandler = get(orderScreenHandlerState);

		return orderScreenHandler.currentTrans;
	}
});
